/** IDs aus Route/Query (`:channelId`, `?thread=`, `?message=`) vor API/Gateway prüfen (Snowflakes, D11). */
const ID_RE = /^\d{1,20}$/;

export function isId(v: string | null | undefined): v is string {
  return typeof v === 'string' && ID_RE.test(v);
}

/** Gültige ID oder null. */
export function safeId(v: string | null | undefined): string | null {
  return isId(v) ? v : null;
}
